
import React from 'react';
import { LoginContainer } from '@/components/auth/login/LoginContainer';

export default function Login() {
  return <LoginContainer />;
}
